import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { DynamicPageBuilderDropdownComponent } from './dynamic-page-builder-dropdown.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { PageBuilderDropdownFormComponent } from './dropdown-form/page-builder-dropdown-form.component';

@NgModule({
    declarations: [
        PageBuilderDropdownFormComponent, DynamicPageBuilderDropdownComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule,
    ],
    entryComponents: [
        DynamicPageBuilderDropdownComponent
    ]
})
export class PageBuilderDropdownModule {}